import React from 'react';
import { Alert } from 'react-bootstrap';
import './Alerts.scss';
import { IAlertsProps } from '../../types/IAlerts';

/**
 *
 * @param param
 * @returns
 */
const Alerts = ({ message, alert }: IAlertsProps) => {
  const alertClass = alert == 'success' ? 'alert-success' : 'alert-danger';
  const alertIcon = alert == 'success' ? 'fa-check-circle' : 'fa-times-circle';
  return (
    <Alert className={`alert ${alertClass}`}>
      <i className={`fa ${alertIcon}`} aria-hidden="true"></i>
      <span>{message}</span>
    </Alert>
  );
};

export default Alerts;
